import {
    ProjectDetailDto,
    ProjectDto,
    ProjectFilterInput,
    ProjectSearchType,
} from "../api/psc";

export const ProjectTypeInfoList = [
    { id: ProjectSearchType.ALL, title: "همه پروژه ها" },
    { id: ProjectSearchType.NEW, title: "پروژه های جدید" },
    { id: ProjectSearchType.VISITED, title: "پروژه های مشاهده شده" },
];

export interface rangeSelectValueProvider {
    min: number;
    max: number;
    step?: number;
    marks?: number[];
    unit: string;
}

export const DefaultProjectImagePath = "/images/placeholder.svg";
export const DefaultDarkProjectImagePath = "/images/placeholder-dark.svg";

export const DefaultMapStyles = `https://api.parsimap.ir/styles/parsimap-streets-v11?key=${process.env.REACT_APP_PARSIMAP_TOKEN}`;
export const DefaultDarkMapStyles = `https://api.parsimap.ir/styles/parsimap-streets-v11-dark?key=${process.env.REACT_APP_PARSIMAP_TOKEN}`;

export const floorRange: rangeSelectValueProvider = {
    min: 1,
    max: 11,
    step: 1,
    marks: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    unit: "طبقه",
};

export const unitRange: rangeSelectValueProvider = {
    min: 1,
    max: 51,
    step: 1,
    marks: [5, 10, 15, 20, 25, 30, 35, 40, 45],
    unit: "واحد",
};

export const subFloorRange: rangeSelectValueProvider = {
    min: 0,
    max: 6,
    step: 1,
    marks: [0, 1, 2, 3, 4, 5, 6],
    unit: "طبقه منفی",
};

export const residentialAreaRange: rangeSelectValueProvider = {
    min: 0,
    max: 25000,
    step: null,
    marks: [0, 2000, 5000, 10000, 25000],
    unit: "متر",
};

export const groundAreaRange: rangeSelectValueProvider = {
    min: 0,
    max: 2000,
    step: null,
    marks: [0, 500, 1000, 2000],
    unit: "متر",
};

export interface ProjectLabelConfig {
    color: string;
    title: string;
}

export const newProjectLabelConfig = {
    color: "#11b84e",
    title: "جدید",
};

export const visitedProjectLabelConfig = {
    color: "#005dba",
    title: "مشاهده شده",
};

export const FolderColors = ["ed9a00", "00ad42", "0088e3", "ff3636", "444444"];

export function GetProjectStatus(
    project: ProjectDto | ProjectDetailDto
): ProjectLabelConfig {
    if (project.isHidden) {
        return { title: "حذف شده", color: "#c21b1b" };
    }

    if (project.isVisited) {
        return visitedProjectLabelConfig;
    }

    return newProjectLabelConfig;
}

export function rangeSelectLabelFormatter(
    valueProvder: rangeSelectValueProvider
): (value: number, index: number) => string {
    return (value: number, index: number) => {
        if (value === valueProvder.max) {
            return `تا ${value} به بالا`;
        }

        if (index === 0) {
            return `از ${value}`;
        } else {
            return `تا ${value}`;
        }
    };
}

export function diffProjectFilter(
    source: ProjectFilterInput,
    destination: ProjectFilterInput
): boolean {
    return (
        source.cityIds.length > 0 ||
        source.regionIds.length > 0 ||
        source.phaseIds.length > 0 ||
        source.onlyWithConstructor !== destination.onlyWithConstructor ||
        source.term !== destination.term ||
        source.structureTypeIds.length > 0 ||
        source.usageTypesIds.length > 0 ||
        source.folderIds.length > 0 ||
        source.floorFrom !== destination.floorFrom ||
        source.floorTo !== destination.floorTo ||
        source.unitFrom !== destination.unitFrom ||
        source.unitTo !== destination.unitTo ||
        source.subFloorFrom !== destination.subFloorFrom ||
        source.subFloorTo !== destination.subFloorTo ||
        source.groundAreaFrom !== destination.groundAreaFrom ||
        source.groundAreaTo !== destination.groundAreaTo ||
        source.residentialAreaFrom !== destination.residentialAreaFrom ||
        source.residentialAreaTo !== destination.residentialAreaTo ||
        source.updateDateFrom !== destination.updateDateFrom ||
        source.updateDateTo !== destination.updateDateTo ||
        source.visitDateFrom !== destination.visitDateFrom ||
        source.visitDateTo !== destination.visitDateTo
    );
}

export enum AccountResetConfiguration {
    VisitedProjects = 1,
    FollowUps = 2,
    Notes = 4,
    SmsCampaigns = 8,
    Folders = 16,
    InvalidDataReports = 32,
}

export function AccountResetConfigurationTitle(
    configuration: AccountResetConfiguration
): string {
    switch (configuration) {
        case AccountResetConfiguration.VisitedProjects:
            return "حذف همه پروژه های مشاهده شده";
        case AccountResetConfiguration.FollowUps:
            return "حذف همه پیگیری ها";
        case AccountResetConfiguration.Notes:
            return "حذف همه یادداشت ها";
        case AccountResetConfiguration.SmsCampaigns:
            return "حذف همه کمپین های پیامکی";
        case AccountResetConfiguration.Folders:
            return "حذف همه پوشه ها";
        case AccountResetConfiguration.InvalidDataReports:
            return "حذف همه گزارشات خطا";
    }
}

export const AccountResetConfigurationList = [
    AccountResetConfiguration.VisitedProjects,
    AccountResetConfiguration.FollowUps,
    AccountResetConfiguration.Notes,
    AccountResetConfiguration.SmsCampaigns,
    AccountResetConfiguration.Folders,
    AccountResetConfiguration.InvalidDataReports,
];
